import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const biRemoveEmployeeFeatureKey = 'biRemoveEmployee';

export interface BusinessInfoRemoveEmployeeState {
  loadBusinessInfoRemoveEmployeeResponse: string;
  loadBusinessInfoRemoveEmployeeFailure: Error | any;
}

export const initialState: BusinessInfoRemoveEmployeeState = {
  loadBusinessInfoRemoveEmployeeResponse: undefined,
  loadBusinessInfoRemoveEmployeeFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBiRemoveEmployeesSuccess, (state, action) => ({
    ...state,
    loadBusinessInfoRemoveEmployeeResponse: action.response
  })),
  on(actions.loadBiRemoveEmployeesFailure, (state, action) => ({
    ...state,
    loadBusinessInfoRemoveEmployeeFailure: action.error
  }))
);
